module.exports = __webpack_public_path__ + "img/photoshop.0b4cbb0a.svg";